import React from 'react'

const ModalBody = (props) => {
    return (
        <div className="relative px-6 pt-5 last:pb-8 flex-auto min-h-0 overflow-y-auto text-sm">
            {props.children}
        </div>
    )
}

export default ModalBody